<div>
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-brand-primary to-brand-accent text-white py-20">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div class="order-2 md:order-1">
          <h1 class="text-5xl font-bold mb-4">Mobile Videowand für Leipzig</h1>
          <p class="text-lg mb-2 opacity-95">
            Ideal für Firmen, Städte und Events mit kurzen Betrachtungsabständen.
          </p>
          <p class="text-sm mb-8 opacity-85 italic">
            Optional: 360° Branding der Videowand im Corporate Design (Seiten, unten, Rückseite)
          </p>
          <div class="space-x-4">
            <a routerLink="/booking" class="inline-block bg-white text-brand-accent font-bold px-8 py-3 rounded-lg hover:shadow-lg transition">
              Verfügbarkeit prüfen
            </a>
            <a href="#use-cases" (click)="scrollToUseCases($event)" class="inline-block bg-transparent border-2 border-white text-white font-bold px-8 py-3 rounded-lg hover:bg-white hover:text-brand-accent transition">
              Mehr erfahren
            </a>
          </div>
        </div>
        <div class="relative rounded-lg overflow-hidden bg-transparent order-1 md:order-2" style="aspect-ratio: 1201/1111;">
          <!-- Alpha-Video -->
          <video
            #heroVideo
            class="w-full h-full object-contain"
            autoplay
            muted
            loop
            playsinline
            preload="auto"
            (loadeddata)="tryPlayHeroVideo()"
            (playing)="videoPlaying = true"
            (pause)="videoPlaying = false"
            title="Videowand Leipzig – Mobile Videolösungen in Aktion"
          >
            <source src="assets/hero_alpha.webm" type="video/webm" />
            Ihr Browser unterstützt das Video-Element nicht.
          </video>
        </div>
      </div>
    </div>
  </section>

  <!-- Use Cases Section - Direkt nach Hero -->
  <section id="use-cases" class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold text-center mb-4">Perfekt für Ihre Veranstaltung</h2>
      <p class="text-center text-gray-600 mb-12 text-lg max-w-3xl mx-auto">
        Unsere mobile Videowand ist die ideale Lösung für vielfältige Einsatzszenarien - 
        von kleinen Events bis zu Großveranstaltungen
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let useCase of useCases" class="bg-gradient-to-br from-gray-50 to-white border border-gray-200 p-6 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
          <div class="text-5xl mb-4">{{ useCase.icon }}</div>
          <h3 class="text-xl font-bold mb-3 text-brand-primary">{{ useCase.title }}</h3>
          <p class="text-gray-600 leading-relaxed">{{ useCase.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Unterschied zu LED-Trailern Section -->
  <section class="py-16 bg-gradient-to-br from-brand-primary/5 to-brand-accent/5">
    <div class="container mx-auto px-4">
      <div class="max-w-5xl mx-auto">
        <h2 class="text-4xl font-bold text-center mb-4">Warum unsere Videowand mehr kann als klassische LED-Trailer</h2>
        <p class="text-center text-gray-700 mb-12 text-lg">
          Der entscheidende Unterschied: Qualität, die man sieht
        </p>
        
        <div class="grid md:grid-cols-2 gap-8 mb-8">
          <!-- Premium Videowand -->
          <div class="bg-white rounded-2xl shadow-lg p-8 border-4 border-brand-accent relative">
            <div class="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-accent text-white px-6 py-2 rounded-full font-bold text-sm">
              Unsere Videowand
            </div>
            <div class="mt-4">
              <div class="text-center mb-6">
                <div class="text-6xl mb-4">✨</div>
                <h3 class="text-2xl font-bold text-brand-primary mb-2">Premium Videowand</h3>
                <p class="text-4xl font-bold text-brand-accent mb-2">2,6mm</p>
                <p class="text-sm text-gray-600">Pixel Pitch</p>
              </div>
              <ul class="space-y-3">
                <li class="flex items-start">
                  <span class="text-green-500 mr-3 text-xl font-bold">✓</span>
                  <span class="text-gray-700"><strong>Gestochen scharf:</strong> Lesbar aus kurzer Distanz</span>
                </li>
                <li class="flex items-start">
                  <span class="text-green-500 mr-3 text-xl font-bold">✓</span>
                  <span class="text-gray-700"><strong>Professionell:</strong> Perfekt für Präsentationen & Logos</span>
                </li>
                <li class="flex items-start">
                  <span class="text-green-500 mr-3 text-xl font-bold">✓</span>
                  <span class="text-gray-700"><strong>Kompakt:</strong> Geringerer Platzbedarf</span>
                </li>
                <li class="flex items-start">
                  <span class="text-green-500 mr-3 text-xl font-bold">✓</span>
                  <span class="text-gray-700"><strong>Flexibel:</strong> Für Indoor & Outdoor Events</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Klassische LED-Trailer -->
          <div class="bg-gray-100 rounded-2xl p-8 border-4 border-gray-300 relative opacity-75">
            <div class="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gray-500 text-white px-6 py-2 rounded-full font-bold text-sm">
              Typische LED-Trailer
            </div>
            <div class="mt-4">
              <div class="text-center mb-6">
                <div class="text-6xl mb-4 opacity-50">📺</div>
                <h3 class="text-2xl font-bold text-gray-600 mb-2">Werbe-LED-Wand</h3>
                <p class="text-4xl font-bold text-gray-500 mb-2">8-16mm</p>
                <p class="text-sm text-gray-500">Pixel Pitch</p>
              </div>
              <ul class="space-y-3">
                <li class="flex items-start">
                  <span class="text-red-500 mr-3 text-xl font-bold">✗</span>
                  <span class="text-gray-500"><strong>Grob:</strong> Nur aus Entfernung lesbar</span>
                </li>
                <li class="flex items-start">
                  <span class="text-red-500 mr-3 text-xl font-bold">✗</span>
                  <span class="text-gray-500"><strong>Basic:</strong> Primär für einfache Werbung</span>
                </li>
                <li class="flex items-start">
                  <span class="text-red-500 mr-3 text-xl font-bold">✗</span>
                  <span class="text-gray-500"><strong>Sperrig:</strong> Großer Anhänger nötig</span>
                </li>
                <li class="flex items-start">
                  <span class="text-red-500 mr-3 text-xl font-bold">✗</span>
                  <span class="text-gray-500"><strong>Eingeschränkt:</strong> Meist nur Outdoor</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-xl shadow-md p-6 border-l-4 border-brand-accent">
          <h4 class="font-bold text-lg mb-3 text-gray-800">💡 Was bedeutet Pixel Pitch?</h4>
          <p class="text-gray-700 leading-relaxed">
            Der Pixel Pitch ist der Abstand zwischen einzelnen LEDs. Bei unserem <strong>2,6mm Pixel Pitch</strong> 
            sitzen die LEDs extrem dicht - das Ergebnis ist ein <strong>gestochen scharfes Bild</strong>, das auch 
            Details und kleine Schrift perfekt darstellt. Klassische Werbe-LED-Wände haben oft 8-16mm Abstand - 
            gut für grobe Werbung aus der Ferne, aber <strong>nicht für professionelle Präsentationen</strong> 
            oder Events mit Nähe zum Publikum geeignet.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Pricing Signal Section -->
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-4xl font-bold mb-4">Transparente Preise</h2>
        <p class="text-gray-600 mb-8 text-lg">
          Keine versteckten Kosten - faire Konditionen für Ihre Veranstaltung
        </p>
        
        <div class="bg-gradient-to-br from-brand-primary to-brand-accent text-white rounded-2xl shadow-2xl p-10 mb-8">
          <div class="mb-6">
            <p class="text-xl opacity-90 mb-2">Mietpreise ab</p>
            <p class="text-6xl font-bold mb-2">490 €</p>
            <p class="text-2xl opacity-90">pro Tag</p>
          </div>
          <div class="text-center mb-4 pb-4 border-b border-white/20">
            <p class="text-sm opacity-90">Keine versteckten Kosten · Eigene Technik · Persönlicher Service</p>
          </div>
          <div>
            <p class="text-lg opacity-95 mb-4 pb-4 border-b border-white/20">
              ✓ Komplette Videowand-Einheit<br>
              ✓ Technische Einweisung<br>
              ✓ Telefonischer Support während der Mietzeit<br>
              ✓ Optional: 360° Branding hinzufügbar
            </p>
            <p class="text-sm opacity-80 mb-4">
              zzgl. Lieferung, Aufbau und Abholung
            </p>
            <p class="text-xl font-semibold bg-white/20 rounded-lg py-3 px-6 inline-block">
              🎯 Langzeitmieten ab 7 Tagen deutlich günstiger
            </p>
          </div>
        </div>

        <div class="grid md:grid-cols-3 gap-6 text-left">
          <div *ngFor="let tier of pricingTiers" class="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:border-brand-accent hover:shadow-lg transition-all">
            <h3 class="font-bold text-lg mb-3 text-brand-primary">{{ tier.name }}</h3>
            <div class="mb-2">
              <p class="text-3xl font-bold text-brand-accent">ab {{ tier.pricePerDay }} €</p>
              <p class="text-sm text-gray-500">pro Tag</p>
            </div>
            <p class="text-xs text-gray-600 mb-3">{{ tier.days }} Tage · ab {{ tier.totalPrice }} € gesamt</p>
            <p class="text-gray-600 text-sm mb-3">{{ tier.description }}</p>
            <p class="text-xs text-gray-500">zzgl. Lieferung & Setup</p>
          </div>
        </div>

        <div class="mt-8">
          <a routerLink="/booking" class="inline-block bg-brand-accent text-white font-bold px-10 py-4 rounded-lg hover:shadow-lg transition text-lg">
            Jetzt verbindlich buchen →
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- 360° Branding Section -->
  <section class="py-16 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-4xl font-bold text-center mb-4">Mehr als Bildschirm: Ihre Marke als komplette Einheit</h2>
        <p class="text-center text-gray-600 mb-12 text-lg">
          Nutzen Sie die volle Kraft Ihres Corporate Designs
        </p>
        
        <div class="grid md:grid-cols-2 gap-8 mb-8">
          <!-- CI-konforme Darstellung -->
          <div class="bg-white rounded-xl shadow-md p-8 border-l-4 border-brand-accent">
            <div class="text-4xl mb-4">🎨</div>
            <h3 class="text-xl font-bold mb-3 text-brand-primary">CI-konforme Darstellung</h3>
            <p class="text-gray-700 leading-relaxed">
              Ihre Videowand präsentiert sich nicht nur auf dem Screen, sondern als komplette, 
              gebrandete Einheit. Seiten, untere Front und Rückseite im Corporate Design – 
              ein konsistentes Markenerlebnis aus allen Blickwinkeln.
            </p>
          </div>

          <!-- Wiederverwendbarkeit -->
          <div class="bg-white rounded-xl shadow-md p-8 border-l-4 border-brand-accent">
            <div class="text-4xl mb-4">♻️</div>
            <h3 class="text-xl font-bold mb-3 text-brand-primary">Wiederverwendbar für Folgemieten</h3>
            <p class="text-gray-700 leading-relaxed">
              Das Branding bleibt bestehen und kann für Folgetermine erneut genutzt werden. 
              Eine nachhaltige Investition in Ihre Markenidentität – ohne jedes Mal neu anfangen zu müssen.
            </p>
          </div>

          <!-- Markenwirkung -->
          <div class="bg-white rounded-xl shadow-md p-8 border-l-4 border-brand-accent">
            <div class="text-4xl mb-4">📸</div>
            <h3 class="text-xl font-bold mb-3 text-brand-primary">Höhere Markenwirkung in Fotos & Videos</h3>
            <p class="text-gray-700 leading-relaxed">
              Jedes Foto, jede Video-Aufnahme Ihrer Veranstaltung zeigt Ihre Marke in voller Größe. 
              Eine professionelle Präsentation, die in sozialen Medien und Presseberichten glänzt.
            </p>
          </div>

          <!-- Professioneller Gesamteindruck -->
          <div class="bg-white rounded-xl shadow-md p-8 border-l-4 border-brand-accent">
            <div class="text-4xl mb-4">⭐</div>
            <h3 class="text-xl font-bold mb-3 text-brand-primary">Professioneller Gesamteindruck</h3>
            <p class="text-gray-700 leading-relaxed">
              Eine komplette, gebrandete Videowand wirkt seriös und durchdacht. 
              Der Eindruck ist hochwertig – ob für Kampagnen, Events, Sponsoring oder Produktpräsentationen.
            </p>
          </div>
        </div>

        <div class="bg-gradient-to-r from-brand-primary/10 to-brand-accent/10 rounded-xl border border-brand-accent/30 p-6 text-center">
          <p class="text-gray-800 leading-relaxed">
            💡 <strong>Das Wichtigste:</strong> Wir stellen die Grafikvorlagen zur Verfügung. 
            Die Grafikerstellung übernehmen Sie – so behalten Sie volle Kontrolle über Ihr Branding 
            und können auf Ihre spezifischen Anforderungen optimieren.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Trust Factors Section -->
  <section class="py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold text-center mb-4">Warum VideoWand Leipzig?</h2>
      <p class="text-center text-gray-600 mb-12 text-lg max-w-3xl mx-auto">
        Ihr verlässlicher Partner für professionelle Videowand im Raum Leipzig
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div *ngFor="let factor of trustFactors" class="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300">
          <div class="text-5xl mb-4">{{ factor.icon }}</div>
          <h3 class="text-xl font-bold mb-3 text-brand-primary">{{ factor.title }}</h3>
          <p class="text-gray-600 leading-relaxed">{{ factor.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold text-center mb-12">Unsere Stärken</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div *ngFor="let feature of features" class="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition">
          <div class="text-4xl mb-4">{{ feature.icon }}</div>
          <h3 class="text-xl font-bold mb-2">{{ feature.title }}</h3>
          <p class="text-gray-600">{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="py-16 bg-gradient-to-br from-gray-50 to-white">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-4xl font-bold text-center mb-4">Häufig gestellte Fragen</h2>
        <p class="text-center text-gray-600 mb-12 text-lg">
          Antworten auf die wichtigsten Fragen rund um die Videowand-Miete
        </p>
        
        <div class="space-y-4">
          <div *ngFor="let faq of faqs; let i = index" class="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition">
            <button 
              (click)="toggleFaq(i)"
              class="w-full text-left px-6 py-5 flex justify-between items-center hover:bg-gray-50 transition"
            >
              <span class="font-bold text-lg text-gray-800 pr-4">{{ faq.question }}</span>
              <span class="text-2xl text-brand-accent flex-shrink-0 transform transition-transform" [class.rotate-180]="faq.open">
                ▼
              </span>
            </button>
            <div 
              class="overflow-hidden transition-all duration-300"
              [class.max-h-0]="!faq.open"
              [class.max-h-96]="faq.open"
            >
              <div class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                <p class="text-gray-700 leading-relaxed">{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-10 text-center bg-white rounded-xl shadow-md p-8 border border-gray-200">
          <h3 class="text-2xl font-bold mb-3 text-brand-primary">Noch Fragen?</h3>
          <p class="text-gray-600 mb-6">
            Wir beraten Sie gerne persönlich und erstellen Ihnen ein individuelles Angebot
          </p>
          <a routerLink="/booking" class="inline-block bg-brand-accent text-white font-bold px-8 py-3 rounded-lg hover:shadow-lg transition">
            Kontakt aufnehmen
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Specifications Section -->
  <section class="py-16">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold text-center mb-12">Technische Spezifikationen</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-brand-primary">Videowand Spezifikationen</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Größe:</strong> 2,5m (Breite) × 1,5m (Höhe)</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Pixel Pitch:</strong> 2,6mm für hochauflösende Bilder</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Mobilität:</strong> Komplette Einheit mit Rollenbasis</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Lieferformat:</strong> Vorkonfigurierte Einheit (keine Einzelmodule)</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Outdoor-tauglich:</strong> Für alle Wetterbedingungen geeignet</span>
            </li>
          </ul>
        </div>

        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-brand-primary">Zugang & Transport</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Transport-Maße:</strong> 2,66m (L) × 2,10m (H) × 0,90m (B)</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Barrierefreiheit:</strong> Rollensystem erfordert ebenene Zufahrt</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Aufbau:</strong> Schnelle Inbetriebnahme vor Ort</span>
            </li>
            <li class="flex items-start">
              <span class="text-brand-accent mr-3 font-bold">✓</span>
              <span><strong>Liefergebiet:</strong> Flexible Entfernungen ab Leipzig</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="bg-gradient-to-r from-brand-primary to-brand-accent text-white py-16">
    <div class="container mx-auto px-4 text-center">
      <h2 class="text-4xl font-bold mb-6">Bereit für Ihre nächste Veranstaltung?</h2>
      <p class="text-xl mb-8 opacity-90">Buchen Sie jetzt eine unserer mobile Videowand</p>
      <a routerLink="/booking" class="inline-block bg-white text-brand-accent font-bold px-8 py-3 rounded-lg hover:shadow-lg transition text-lg">
        Zur Buchung →
      </a>
    </div>
  </section>
</div>
